import { render } from "./banners.html?vue&type=template&id=ce675c46&ts=true"
import script from "./banners.vue?vue&type=script&lang=ts"
export * from "./banners.vue?vue&type=script&lang=ts"

import "./banners.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__